import { Route, Routes } from "react-router-dom";
import Entry from "../pages/Entry";
import BreakerGamePage from "../pages/games/BreakerGamePage";
import GuessNumberGamePage from "../pages/games/GuessNumberGamePage";
import TikTakToeGamePage from "../pages/games/TikTakToePage";
import HomePage from "../pages/home/HomePage";
import MemoryMatchGamePage from "../pages/games/MemoryMatchGamePage";
import CosmicRacerGamePage from "../pages/games/CosmicRacer";
import AutoDonatePage from "../pages/AutoDonatePage";
import GameOfLifeGamePage from "../pages/games/GameOfLifeGame";

export default function RouterPage() {
  return (
    <Routes>
      <Route path="/" element={<Entry />} />
      <Route path="/HOME" element={<HomePage />} />
      <Route path="/game/tiktaktoe" element={<TikTakToeGamePage />} />
      <Route path="/game/guess-number" element={<GuessNumberGamePage />} />
      <Route path="/game/wall-breaker" element={<BreakerGamePage />} />
      <Route path="/game/memory-match" element={<MemoryMatchGamePage />} />
      <Route path="/game/game-of-life" element={<GameOfLifeGamePage />} />
      <Route path="/game/cosmic-racer" element={<CosmicRacerGamePage />} />
      <Route path="/donate/:amount" element={<AutoDonatePage />} />

      {/* New route added */}
      {/* Add more routes here as needed */}
      {/* Example: <Route path="/another-page" element={<AnotherPage />} /> */}
      {/* Adding an additional route as an example */}
      {/* <Route path="/another-page" element={<AnotherPage />} /> */}
    </Routes>
  );
}
